module.exports = __webpack_public_path__ + "static/media/RBG_art_German_DiCiccio.6189e2cb.png";